import { render } from "./TheReserveDay.vue?vue&type=template&id=71be1061&scoped=true&ts=true"
import script from "./TheReserveDay.vue?vue&type=script&lang=ts"
export * from "./TheReserveDay.vue?vue&type=script&lang=ts"

import "./TheReserveDay.vue?vue&type=style&index=0&id=71be1061&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71be1061"]])

export default __exports__